import { injectGlobal } from 'styled-components'
import styledTheme from './theme'
import MontserratRegular from '../assets/fonts/montserrat-regular.otf'
import MontserratLight from '../assets/fonts/montserrat-light.otf'
import LucidaGrandeRegular from '../assets/fonts/lucidagrande-webfont.otf'
import LucidaGrandeBold from '../assets/fonts/lucidagrande-bold-webfont.otf'

injectGlobal`

  @font-face {
    font-family: 'LucidaGrande';
    font-style: normal;
    font-weight: normal;
    src: url('${LucidaGrandeRegular}') format('opentype');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215;
  }
  @font-face {
    font-family: 'LucidaGrande';
    font-style: normal;
    font-weight: bold;
    src: url('${LucidaGrandeBold}') format('opentype');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215;
  }
  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    src: url('${MontserratRegular}') format('opentype');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215;
  }
  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 300;
    src: url('${MontserratLight}') format('opentype');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215;
  }

  html, body {
    height: 100%;
    width: 100%;
    max-width: 1600px;
    padding: 0;
    margin: 0 auto;
    color: #444;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: none;
  }

  body {
    margin: 0 auto;
    padding: 0;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: normal;

    a, a:link, a:hover, a:visited, a:active {
      color: ${styledTheme.colors.action_link};
    }
  }

  * {
    box-sizing: border-box;
  }

  #app {
    height: 100%;
  }

  span.nowrap {
    white-space: nowrap;
  }
`



// WEBPACK FOOTER //
// ./src/styles/global-styles.js